import { Component, Inject } from '@angular/core';
import { Language } from '@obo-main/services/language/language.models';
import { PortalRegion } from '@obo-portal/models/portal.models';
import { ActiveModal } from '@obo-main/services/modal/activeModal.model';
import { LocationService } from '@obo-main/services/location/location.service';
import { AlertService } from '@obo-main/services/common/alert/alert.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-region-language-selector-modal',
    templateUrl: './regionLanguageSelectorModal.component.html',
    styleUrls: ['./regionLanguageSelectorModal.component.scss'],
    exportAs: 'regionLanguageSelectorModal',
    standalone: false
})
export class RegionLanguageSelectorModalComponent {
    public showRegionSelection: boolean = true;

    constructor(
        @Inject('portalRegions')
        public portalRegions: PortalRegion[],
        @Inject('selectedRegion')
        public selectedRegion: PortalRegion | undefined,
        @Inject('saveRegionFn')
        public saveRegionFn: (region: PortalRegion) => void,
        @Inject('languages')
        public languages: Language[],
        @Inject('selectedLanguage')
        public selectedLanguage: Language | undefined,
        @Inject('saveLanguageFn')
        public saveLanguageFn: (language: Language) => void,
        @Inject('isDismissible')
        public isDismissible: boolean,
        @Inject(ActiveModal)
        public activeModal: ActiveModal,
        @Inject(Window)
        private window: Window,
        public locationService: LocationService,
        public alertService: AlertService,
        public translateService: TranslateService
    ) {}

    public submit(): void {
        this.saveLanguageFn(this.selectedLanguage);
        this.saveRegionFn(this.selectedRegion);
        this.activeModal.close();
        this.window.location.reload();
    }

    public locateBrowserAndSetRegion(): void {
        this.locationService
            .getCoordinates()
            .then((pos) => {
                this.locationService
                    .getPortalRegionByGeoPosition(pos)
                    .pipe()
                    .subscribe((region) => {
                        this.selectedRegion = region;
                        // Example: Region { id: 1, name: 'DE' }, Language { displayName: 'Deutsch', .... , name: 'de-DE' }
                        this.selectedLanguage = this.languages.find((lang) => lang.name.endsWith(region.name));
                    });
            })
            .catch((error) => {
                this.alertService.danger(this.translateService.instant('LANGUAGE_SELECT_LOCATION_ERROR'));
            });
    }
}
